import Tooltip from "@mui/material/Tooltip"

type TooltipIfEnabledProps = {
  enabled: boolean
  label: React.ReactNode
  index?: number
  children: React.ReactElement
}

export const TooltipIfEnabled: React.FC<TooltipIfEnabledProps> = ({
  enabled,
  label,
  children,
}) => {
  if (!enabled) return children

  return (
    <Tooltip title={label}>
      {children}
    </Tooltip>
  )
}
